import api from './api.js';
import { Table } from './scripts/table/table.js';

api.Table = Table;

export default api;
